<template>
	<div id="pg1" >  
		<section class="eres-empleador">
						<img v-responsive.xl.lg src="@/assets/landing/empleador/home/empleadorhome-1680x1050.png"
							 class="section_img" >
						<img v-responsive.md src="@/assets/landing/empleador/home/empleadorhome-1024x768.jpg"
							 class="section_img">
						<img v-responsive.xs.sm src="@/assets/landing/empleador/home/empleadorhome-768x1024.jpg"
							 class="section_img" >

			<div class="hyper-link">
				<div :class="isMobile ? 'row justify-content-center' : 'row'" >
					<div class="col-10 col-md-5">
						<h2 :class="isMobile ? 'font-blue text-center' : 'font-blue'" :style="isMobile ? 'font-size:17px;' : ''">¡Qué esperas!</h2>
						<input type="email" :class="isMobile ? 'form-control form-control-sm' : 'form-control'"
							   v-model="email.val"
							   id="send_email"
							   placeholder="Escribe tu dirección de correo">
					</div>
					<div class="col-10 col-md-5">
						<center>
							<h2 id="titleButtonEmail" style="color: transparent">¡!</h2>
							<button id="buttonEmail"
									type="submit"
									:class="isMobile ? 'btn b-orange w-50 align-center' : 'btn b-orange w-70'"
									@click.prevent="sendEmail"
									:style="isMobile ? 'margin-top: -45px;' : ''">
								<b-spinner v-show="sendLoading" small label="Espere ..."/>
								¡Comienza Ahora!
							</button>
						</center>
					</div>
					<div class="col-md-2"></div>
				</div>

			</div> 
			<div id="down" >
				<div class="center">
					<img src="@/assets/landing/arrow-down.gif" width="50px">
				</div>
			</div>
			<div id="porqueKllaarcom"  >

				<div class="center">

					<b-button v-b-modal.porquekllaar class="b-transparent m-3">
						<span class="h2 text-white">Por qué Kllaar.com</span>
					</b-button>

				</div>
			</div>

		</section>
		<b-modal id="porquekllaar" centered hide-footer hide-header size="lg">
			<div>
				<img src="@/assets/landing/empleador/home/por_que_kllaar.jpg"  class="img-fluid" alt="Responsive image" style="transparent">
				<center>
					<a href="/acerca-de" class="btn b-orange" style="margin-top:-110%;">
						Conoce más
					</a>
				</center>				
			</div>
		</b-modal>
	</div>
</template>

<script>
export default {
	name: "empleador",
	data() {
		return {
			isMobile: this.$mobile(),
			sendLoading: false,
			email: {
				valid: null,
				val: ""
			},
		}
	},

	watch:{
		email: {
			deep: true,
			handler() {

				if (this.email.val && this.email.val.length > 1) {
					let regx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
					this.email.val !== null && this.email.val  !== "" && regx.test(this.email.val)
						? (this.email.valid = true)
						: (this.email.valid = false);
				}
			}
		},
	},
	methods:{

		sendEmail(){

			this.sendLoading = true

			if (this.email.valid){

				this.api.post('enterprise/subscribe', {
					email:this.email.val
				}).then(({data}) => {
					this.sendLoading = false
					this.email= {
							valid: null,
							val: ""
						}
					
					this.toast(data.data, 'success')
					return false
				}).catch(err => {
					this.sendLoading = false
					if(err){
						this.toast(data.errors.general, 'danger')
						return false
					}
				})

			}else{
				this.toast('Email requerido', 'warning')
				this.sendLoading = false
			}

		},
		toast(msg,variant) {
			this.$bvToast.toast(msg, {
				title: "Kllaar.com",
				variant: variant,
				toaster: 'b-toaster-bottom-right',
				solid: true,
				appendToast: true
			})
		}
	} 
}
</script>

<style scoped lang="scss">
.section_img {
	width: 100%;
	z-index: 1;
}
.eres-empleador{
	position:relative; 
}
.eres-empleador .hyper-link a{
	font-size: large;
}
.eres-empleador #porqueKllaarcom{
	position: absolute;
	bottom: -45px;
	right:0;
	z-index:3;
	width: 100%;
	background: #00366a;
	color: #fff;


}
.eres-empleador #down{
	position: absolute;
	bottom: -20%;
	right:0;
	z-index: -1;
	width: 100%;
	img{
		cursor: pointer;
	} 
}
.center {
	width: 100%;
	height: 100%;
	text-align: center;
}
.eres-empleador .hyper-link{
	position: absolute;
	bottom: 20%;
	right: 10%;
	width: 40%;
	z-index: 2;

 
	@media only screen and (min-width: 320px)  and (max-device-width: 581px)  {
		top: 64%;
		width: 80%;
		#buttonEmail{
			min-width: 65%;
		}
	}

	@media only screen and (min-width: 768px) {
		bottom: 30%;
		width: 60%;
		#buttonEmail{
			min-width: 65%;
		}
	}
	@media only screen and (min-width: 960px) {
		bottom: 23%;
		right: 5%;
		width: 56%;
	}
	@media only screen and (min-width: 1440px) {
		bottom: 30%;
		right: 3%;
		width: 44%;
	}
	@media only screen and (min-width: 2000px) {
		bottom: 20%;
		width: 44%;
	}
	@media only screen and (max-device-width: 480px) {
		bottom: 15%;
		width: 80%;
	}
	@media only screen and (device-width: 768px) {
		bottom: 15%;
		width: 80%;
	}
	// /* different techniques for iPad screening */
	// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
	// 	bottom: 15%;
	// 	width: 80%;
	// }

	// @media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
	// 	/* For landscape layouts only */
	// 	bottom: 15%;
	// 	width: 80%;
	// }
}

.eres-empleador {


	@media only screen and (min-width: 480px) {
		//margin-top: -45px;
	}
	@media only screen and (min-width: 768px) {
	}
	@media only screen and (min-width: 960px) {
	}
	@media only screen and (min-width: 1440px) {
		margin-top: -45px;
	}
	@media only screen and (min-width: 2000px) {
	}
	@media only screen and (max-device-width: 480px) {
	}
	@media only screen and (device-width: 768px) {
	}
	/* different techniques for iPad screening */
	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
	}

	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
	}
}

</style>



// WEBPACK FOOTER //
// src/views/landing/empleador/home.vue